import { get } from '../utils/api';

class IncomeTypeService {
  getAll(options?: Object) {
    return get('/incomeTypes', options);
  }
}

export default IncomeTypeService;
